import {NgModule} from '@angular/core';
import {IneligibilityOverlayComponent} from '@blocks/input/ineligibility-overlay/ineligibility-overlay.component';
import {TranslocoModule} from '@ngneat/transloco';

@NgModule({
  declarations: [
    IneligibilityOverlayComponent
  ],
  imports: [
    TranslocoModule
  ],
  exports: [
    IneligibilityOverlayComponent
  ]
})
export class IneligibilityOverlayModule { }
